var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEducation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9155",
    "data-name": "Group 9155",
    transform: "translate(0 0.044)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9135",
    "data-name": "Group 9135",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1647",
    "data-name": "Ellipse 1647",
    cx: 53,
    cy: 53,
    r: 53,
    transform: "translate(0 -0.044)",
    fill: "#ff6565"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    transform: "translate(15.28 56.653) rotate(-30)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_001---Degree",
    "data-name": "001---Degree",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M64.578,0a1.107,1.107,0,0,0-.2.018A189.7,189.7,0,0,1,33.988,2.266,189.7,189.7,0,0,1,3.6.018,1.278,1.278,0,0,0,3.4,0C2.606,0,0,.9,0,12.462S2.606,24.925,3.4,24.925a1.291,1.291,0,0,0,.2-.02A177.194,177.194,0,0,1,26.94,22.777l-2.212,5.3a2.257,2.257,0,0,0,2.994,2.908l.867-.37.375.862a2.253,2.253,0,0,0,2.083,1.374h.028a2.258,2.258,0,0,0,2.077-1.414l1.968-4.711,1.961,4.693a2.266,2.266,0,0,0,2.083,1.432H39.2a2.25,2.25,0,0,0,2.076-1.36l.378-.869.853.366a2.258,2.258,0,0,0,3-2.922l-2.168-5.2A172.744,172.744,0,0,1,64.381,24.91a1.106,1.106,0,0,0,.2.015c.793,0,3.4-.9,3.4-12.462S65.371,0,64.578,0ZM37.614,4.5a23.86,23.86,0,0,1,.817,5.3,7.861,7.861,0,0,0-7.886.733,30.608,30.608,0,0,0-.778-6.041q2.059.043,4.222.043C35.227,4.532,36.429,4.518,37.614,4.5ZM35.121,22.659a5.665,5.665,0,1,1,5.665-5.665A5.665,5.665,0,0,1,35.121,22.659ZM3.4,2.832a31.776,31.776,0,0,1,1.133,9.63A31.776,31.776,0,0,1,3.4,22.092a31.776,31.776,0,0,1-1.133-9.63A31.776,31.776,0,0,1,3.4,2.832ZM5.687,22.285c.62-1.8,1.11-4.8,1.11-9.823S6.307,4.437,5.686,2.637A198.774,198.774,0,0,0,27.4,4.431a29.164,29.164,0,0,1,.924,8.031c0,.164,0,.321-.007.478a7.849,7.849,0,0,0-.365,7.423l-.05.12a197.316,197.316,0,0,0-22.215,1.8Zm25.363,8.3-.827-1.9a1.133,1.133,0,0,0-1.485-.589l-1.907.843,2.657-6.369a7.923,7.923,0,0,0,4,2.187ZM41.5,28.1a1.133,1.133,0,0,0-1.485.589l-.838,1.884-2.429-5.815a7.931,7.931,0,0,0,4-2.188l2.651,6.344ZM64.351,22.6a183.485,183.485,0,0,0-21.979-2.039l-.08-.195a7.884,7.884,0,0,0-1.527-8.934,31.534,31.534,0,0,0-.809-6.98,189.111,189.111,0,0,0,24.4-2.132c.526.893,1.36,4.424,1.36,10.141S64.871,21.709,64.351,22.6Z",
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.4
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEducation);
export default __webpack_public_path__ + "static/media/Education.01f3c2e9b068c96eb623ea591b3ef6e7.svg";
export { ForwardRef as ReactComponent };